import { useMutation } from "@tanstack/react-query";
import { privateApi } from "../../../api/api";
import { ValidationErrorResponse } from "../../common/response/ValidationErrorResponse";
import { SendEmailReservationOtaType } from "../schema/SendEmailReservationOtaSchema";
import { SendEmailReservationOtaResponseSchema } from "../response/SendEmailReservationOtaResponse";

export const useSendEmailReservationOta = () => {
    return useMutation({
        mutationFn: async (formData: SendEmailReservationOtaType) => await privateApi.post(`/v3/send-email-reservation-ota`, formData),
        onSuccess: async (response) => {
            try {
                const validationResult = SendEmailReservationOtaResponseSchema.safeParse(response.data);

                if (!validationResult.success) {
                    console.error("Validation failed:", validationResult.error.errors);
                    throw new Error("Invalid send email data format");
                }

                return validationResult.data
            } catch (error) {
                console.error('Failed to create send email', error);
                throw error;
            }
        },
        onError: (error) => {
            const validationResult = ValidationErrorResponse.safeParse((error as any).response.data);

            if (!validationResult.success) {
                console.error("Validation failed:", validationResult.error.errors);
                throw new Error("Invalid send email data format");
            } else {
                console.error(`Failed to create send email`, error);
                throw error;
            }
        }
    });
};